import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import ConfigurationDataEditDialog from '../../Dialogs/Configuration/ConfigurationDataEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function ConfigurationDataTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getConfigurationData = async function () {
            let url = `api/v1/configurationdata/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getConfigurationData();
    }, [fetchDataAuthenticated, includeDeleted, refresh]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'Value',
            accessor: 'value',
            filter: 'includesString'
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    const initialState = {
        sortBy: [
            {
                id: 'name',
                desc: false
            },
            {
                id: 'businessUnit',
                desc: false
            }
        ]
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={initialState} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function ConfigurationDataConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewConfigurationData = () => {
        return { configurationDataId: null, name: "", value: "", description: "", businessUnitId: null, isDeleted: false }
    };

    return (
        <CommonConfigPage
            title="Configuration Data"
            Table={ConfigurationDataTable}
            Dialog={ConfigurationDataEditDialog}
            getNewConfigObject={getNewConfigurationData}
            businessUnits={businessUnits}
        />
    );
}

export default ConfigurationDataConfiguration;